import { CircularProgress, Stack } from "@mui/material";

export default function FullPageLoader() {
  return (
    <Stack direction="row" minHeight="50vh" alignItems="center" justifyContent="center" width="100%">
      <CircularProgress />
    </Stack>
  );
}
